// extracted by mini-css-extract-plugin
export var attachButton = "_jg-8";
export var sendButton = "_jg-2";
export var sendDisabled = "_jg-4";
export var sendEnabled = "_jg-3";
export var sendIcon = "_jg-6";
export var sendIconDisabled = "_jg-7";
export var sendStreaming = "_jg-5";
export var textarea = "_jg-1";
export var wrapper = "_jg-0";